import { useEffect, useState, useRef } from "react";
import {
  SendOutlined,
  HistoryOutlined,
  CloseOutlined,
  UpOutlined,
  DownOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import { Modal } from "antd";
import AskAiQuestion from "../../functions/merchant/askAiQuestion";
import { useLoading } from "../../context/loadingContext";
import { bg_button } from "constant/css";
import ImageViewer from "components/other/imageViewer";

const MerchantHelperPopup = ({ ref, close }) => {
  const [loading, setLoading] = useState(false);
  const [problem, setProblem] = useState("");
  const [data, setData] = useState([]);
  const [zoomImage, setZoomImage] = useState(null);
  const chatContainerRef = useRef(null);
  const [showSuggestions, setShowSuggestions] = useState(true);

  const suggestions = [
    "Үнийн мэдээлэл авах?",
    "Алдаа гарвал хэнд хандах вэ?",
    "Нэхэмжлэл яаж шалгах вэ",
    "Нэхэмжлэл үүсгэх заавар",
    "Гарын авлага харах?",
  ];
  const scrollToBottom = () => {
    setTimeout(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    }, 100);
  };

  const send = async () => {
    if (!problem.trim()) return;

    const userMessage = {
      role: "user",
      problem: problem,
      createdAt: new Date().toLocaleString(),
    };

    setData((prev) => [...prev, userMessage]);
    setProblem("");
    setLoading(true);
    scrollToBottom();

    const response = await AskAiQuestion(problem);
    if (response && response.success) {
      const aiMessage = {
        role: "ai",
        answer: response.data.answer,
        image: response.data.image,
        createdAt: new Date().toLocaleString(),
      };
      setData((prev) => [...prev, aiMessage]);
    }

    setLoading(false);
    scrollToBottom();
  };

  return (
    <div
      ref={ref}
      className="absolute bottom-full mb-4 -left-[90px] -translate-x-1/2 bg-white shadow-2xl rounded-xl w-80 z-50 border border-gray-200 flex flex-col overflow-hidden"
    >
      <div
        className={`${bg_button} px-4 py-2 border-b text-sm font-medium flex items-center justify-between`}
      >
        <span className="text-white">AI тусламж</span>
        <CloseOutlined onClick={close} style={{ color: "#fff" }} />
      </div>

      <div
        ref={chatContainerRef}
        className="h-60 overflow-y-auto px-3 py-2 space-y-3 bg-white"
      >
        {data.length > 0 ? (
          data.map((item, idx) => (
            <div
              key={idx}
              className={`flex ${
                item.role === "user" ? "justify-end" : "justify-start"
              }`}
            >
              <div
                className={`max-w-[75%] break-words whitespace-pre-wrap px-3 py-2 rounded-xl text-sm shadow ${
                  item.role === "user"
                    ? `${bg_button} text-white rounded-br-none`
                    : "bg-gray-100 text-gray-800 rounded-bl-none"
                }`}
              >
                <div>{item.role === "user" ? item.problem : item.answer}</div>
                <div className="text-[10px] text-gray-300 mt-1 text-right">
                  {item.createdAt}
                </div>
                {item.image && (
                  <img
                    src={`https://storage.googleapis.com/smartbilling_hubilai/ai/${item.image}`}
                    alt="answer"
                    onClick={() =>
                      setZoomImage(
                        `https://storage.googleapis.com/smartbilling_hubilai/ai/${item.image}`
                      )
                    }
                    className="mt-2 rounded-lg max-w-full cursor-pointer hover:opacity-80 transition"
                  />
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="text-center text-xs text-gray-400 pt-10">
            Түүх алга
          </div>
        )}
      </div>
      {/* suggestions side */}
      <div className="border-t border-gray-200 bg-white">
        {/* Toggle Button */}
        <div
          className="flex items-center justify-center px-3 py-1 cursor-pointer select-none"
          onClick={() => setShowSuggestions(!showSuggestions)}
        >
          <span className="text-xs text-gray-500 mr-1">
            {!showSuggestions ? <CaretUpOutlined /> : <CaretDownOutlined />}
          </span>
        </div>

        {/* Suggestions */}
        {showSuggestions && (
          <div className="px-3 pb-2 flex flex-wrap gap-2">
            {suggestions.map((question, idx) => (
              <div
                key={idx}
                onClick={() => {
                  setProblem(question);
                  setTimeout(() => {
                    send();
                    scrollToBottom();
                  }, 400);
                }}
                className="cursor-pointer bg-gray-100 hover:bg-blue-100 text-xs text-gray-700 px-3 py-1 rounded-full transition"
              >
                {question}
              </div>
            ))}
          </div>
        )}
      </div>
      {/* input side */}
      <div className="p-3 bg-white flex items-center gap-2">
        <input
          type="text"
          value={problem}
          onChange={(e) => setProblem(e.target.value)}
          placeholder="Асуудлаа бичнэ үү..."
          className="flex-1 px-3 py-2 border rounded-full text-sm focus:outline-none focus:ring focus:border-blue-300"
          disabled={loading}
          onKeyDown={(e) => e.key === "Enter" && send()}
        />
        <button
          onClick={send}
          disabled={!problem.trim() || loading}
          className="bg-blue-500 hover:bg-blue-600 text-white p-2 rounded-full transition"
        >
          <SendOutlined />
        </button>
      </div>

      <ImageViewer imageUrl={zoomImage} onClose={() => setZoomImage(null)} />
    </div>
  );
};

export default MerchantHelperPopup;
